/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : DynamicFormTemplatesPage.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import TemplateLayout from "../Templates/TemplateLayout";
import TemplateManager from "../Templates/TemplateManager";
import dynamicTemplateAction from "../../../redux/actions/dynamicTemplateAction";
import ViewDynammicFormDetails from "./ViewDynammicFormDetails";
import PreviewModal from "../DynamicFormV2/PreviewModal";
import UpdateDynamicForm from "./UpdateDynamicForm";
import { useDispatch, useSelector } from "react-redux";
import { HandleApiActions } from "../../../redux/actions";

function DynamicFormTemplatesPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const getFormDetails = useSelector((state) => state.dynamicTemplateReducer);

  const [singleFormDetails, setSingleFormDetails] = useState({});
  const [updateFormDetails, setUpdateFormDetails] = useState({});
  const [openNewPreview, setOpenNewPreview] = useState(false);
  const [open, setOpen] = useState(false);
  const [updateForm, setUpdateForm] = useState(false);
  const [page] = useState(1);
  const [rowsPerPage] = useState(25);

  const handleClose = (index) => {
    if (index === 1) {
      setOpen(false);
    } else if (index === 2) {
      setUpdateForm(false);
    } else if (index === 3) {
      setOpenNewPreview(false);
    }
  };

  const handleOpen = (dataId) => {
    const singleFormDetails = getFormDetails?.dynamicTemplate?.find(
      (item) => item?.id === dataId,
    );
    console.log(singleFormDetails, "singleFormDetails");
    if (singleFormDetails.template_tag === "OLD") {
      setSingleFormDetails(structuredClone(singleFormDetails));
      setOpen(true);
    } else if (singleFormDetails.template_tag === "NEW") {
      setSingleFormDetails(structuredClone(singleFormDetails));
      setOpenNewPreview(true);
    }
  };

  const handleOpenUpdate = (data) => {
    console.log(data, "data in edit");

    if (data.template_tag === "OLD") {
      const updateFormDetails = getFormDetails?.dynamicTemplate?.find(
        (item) => item?.id === data.id,
      );

      if (!updateFormDetails) return;

      const clonedForm = structuredClone(updateFormDetails);
      setUpdateFormDetails(clonedForm);
      setUpdateForm(true);
    } else if (data.template_tag === "NEW") {
      navigate(`/dashboard/dynamicform?id=${data.id}`);
    }
  };

  useEffect(() => {
    dispatch(
      HandleApiActions({
        ...dynamicTemplateAction.get_d_template,
        params: {
          page_number: page,
          page_size: rowsPerPage,
        },
      }),
    );
  }, [open, updateForm, page, rowsPerPage, dispatch]);

  const breadcrumbs = [
    { label: "Settings" },
    { label: "Feature Portfolio" },
    { label: "Dynamic Form Templates" },
  ];

  const config = {
    fetchAction: dynamicTemplateAction.get_d_template,
    selector: (state) => state.dynamicTemplateReducer,
    onEdit: (item) => {
      handleOpenUpdate(item);
    },
    onView: (item) => {
      handleOpen(item.id);
    },
  };
  return (
    <Box
      sx={{
        "& ::-webkit-scrollbar": {
          width: "8px",
          height: "8px",
        },
        "& ::-webkit-scrollbar-track": {
          background: "#f1f1f1",
        },
        "& ::-webkit-scrollbar-thumb": {
          background: "#888",
          borderRadius: "4px",
        },
        "& ::-webkit-scrollbar-thumb:hover": {
          background: "#555",
        },
        scrollbarColor: "#888 #f1f1f1",
        scrollbarWidth: "thin",
      }}
    >
      <TemplateLayout
        breadcrumbs={breadcrumbs}
        addButtonConfig={{
          show: true,
          label: "Create",
          onClick: () => navigate("/dashboard/dynamicform"),
        }}
      >
        <TemplateManager config={config} />
      </TemplateLayout>
      {open && (
        <ViewDynammicFormDetails
          data={singleFormDetails}
          open={open}
          handleClose={() => handleClose(1)}
        />
      )}
      {openNewPreview && (
        <PreviewModal
          isOpen={openNewPreview}
          onClose={() => handleClose(3)}
          pages={singleFormDetails?.fields}
          title={singleFormDetails?.name}
        />
      )}
      <UpdateDynamicForm
        data={updateFormDetails}
        open={updateForm}
        handleClose={() => handleClose(2)}
      />
    </Box>
  );
}

export default DynamicFormTemplatesPage;
